"use client";

import Link from "next/link";
import { HiArrowRight, HiSparkles } from "@/components/icons";

export default function BlogCustomDevCTA() {
  return (
    <div className="mt-20 pt-10 border-t border-border/50">
      <div className="relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-background to-primary/5 p-8 md:p-10">
        {/* Background Decorative Elements */}
        <div className="absolute top-0 right-0 -mt-10 -mr-10 h-32 w-32 rounded-full bg-primary/10 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -mb-10 -ml-10 h-32 w-32 rounded-full bg-blue-500/10 blur-3xl"></div>

        <div className="relative z-10 flex flex-col md:flex-row gap-8 items-center justify-between">
          <div className="flex-1 space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-mono font-bold border border-primary/20 w-fit">
              <HiSparkles className="w-3 h-3" />
              <span>NEED SOMETHING CUSTOM?</span>
            </div>

            <h3 className="text-2xl md:text-3xl font-bold tracking-tight">
              Don't see the tool you need? <br className="hidden md:block" />
              <span className="text-primary">We'll build it for you.</span>
            </h3>

            <p className="text-muted-foreground max-w-lg leading-relaxed">
              Stop renting your workflow. We build custom browser extensions that automate your
              specific manual processes, data extraction, and repetitive tasks.
            </p>
          </div>

          <div className="flex-shrink-0">
            <Link
              href="/custom-extension-quote/"
              className="group inline-flex items-center justify-center h-14 px-8 rounded-xl bg-primary text-primary-foreground font-bold text-lg shadow-lg hover:bg-primary/90 hover:scale-105 transition-all duration-300"
            >
              Get a Quote
              <HiArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            <p className="text-center text-xs text-muted-foreground mt-3">
              Fixed price. 100% IP Ownership.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
